import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  width: 25.5rem;
`;
export const TextContainer = styled.p`
  font-weight: 600;
  font-size: 1.9rem;
  color: black;
  text-align: center;
  margin-top: 0;
  letter-spacing: 0.3px;
`;
